import { useRemovePopularEnabled } from './useRemovePopularEnabled';
import { useExperimentGroup } from './useExperimentGroup';
import { SNR_DESKTOP_SR135_REMOVE_POPULAR } from '../constants/experiments';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253219, будет удалён в задаче CD-253242
 */
export const useRemovePopularExperiment = () => {
  const isEnabled = useRemovePopularEnabled();
  const experimentGroup = useExperimentGroup(SNR_DESKTOP_SR135_REMOVE_POPULAR);

  return { isEnabled, experimentGroup };
};
